import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4" data-id="element-171">
      <div className="max-w-3xl mx-auto" data-id="element-172">
        <div className="flex items-center gap-4 mb-8 justify-center md:justify-start" data-id="element-173">
          <AlertCircle className="w-10 h-10 text-[#E74C3C]" data-id="element-174" />
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-175">
            ¿Te pasa esto?
          </h2>
        </div>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed bg-white/5 p-8 md:p-10 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-176">
          <p data-id="element-177">
            Vendés infoproductos. Ebooks, cursos, programas. Sabés que tu
            conocimiento tiene valor.
          </p>
          <p data-id="element-178">
            Pero también sabés que vender no es solo "tener un buen producto".
          </p>
          <p className="font-medium text-white" data-id="element-179">
            Necesitás escribir la landing. Armar los emails. Crear los anuncios.
            Pensar los ángulos publicitarios. Hacer el copy del checkout.
            Planificar el lanzamiento. Diseñar los bonus. Analizar las métricas.
            Briefear al editor. Organizar la semana.
          </p>
          <p className="text-[#E74C3C] font-semibold text-xl" data-id="element-180">
            Son 15 trabajos diferentes. Y los estás haciendo todos vos.
          </p>
          <p data-id="element-181">
            Probaste usar ChatGPT o Claude para ayudarte. Le pedís que te
            escriba un email, te da algo genérico. Le pedís un script de
            anuncio, te da algo que suena a robot. Le pedís que analice tu
            campaña… y no sabe ni por dónde empezar.
          </p>
          <div className="bg-[#0B1D3A] p-6 rounded-xl border border-[#00B4D8]/30 mt-8" data-id="element-182">
            <p className="font-bold text-white text-xl mb-2" data-id="element-183">¿El problema?</p>
            <p className="text-[#00B4D8]" data-id="element-184">
              La IA es tan buena como las instrucciones que le das. Y nadie te
              enseñó a darle las instrucciones correctas para vender
              infoproductos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}